import React from 'react';
import { View, Text, StyleSheet, Pressable, Image } from 'react-native';

import { __WEB__, COLOR, FONT, FONT_SIZE, THEME } from '../../constants/styles';

import { I18n, ArrowRight } from '../components';

const EXPORT_IMAGE_SOURCE = require('../../../resources/icon-logout.png');

export function ExportButton(props) {
  const { onPress, disabled } = props;
  return (
    <Pressable
      style={{
        flexDirection: 'row',
        alignContent: 'center',
        alignItems: 'center',
        marginRight: 5,
      }}
      onPress={onPress}
    >
      <Image
        source={EXPORT_IMAGE_SOURCE}
        style={{ width: 9, height: 9, tintColor: COLOR.textLight }}
      />
      <Text
        style={{
          marginLeft: 5,
          ...FONT.regular,
          fontSize: FONT_SIZE.tiny,
          color: COLOR.textLight,
        }}
      >
        EXPORT
      </Text>
    </Pressable>
  );
}

export const Tile = (props) => {
  return (
    <View style={[styles.container, props.containerStyle]}>
      <View style={styles.floatingHeader}>
        <Text style={[FONT.bold, { color: props.disabled ? COLOR.textLight : COLOR.text }]}>
          {props.title}
        </Text>
        {!!props.onPress && (
          <Pressable style={THEME.basicRow} onPress={props.onPress}>
            <Text style={styles.detailsText}>{'Details'}</Text>
            <ArrowRight style={styles.arrowStyle} />
          </Pressable>
        )}
        {/*<ExportButton onPress={props.onExport} />*/}
      </View>
      <View>{props.children}</View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    height: __WEB__ ? '100%' : 'auto',
    width: __WEB__ ? '100%' : 'auto',
    borderWidth: 1,
    borderColor: COLOR.altAccent,
    shadowColor: COLOR.altAccent,
    shadowOffset: { width: 3, height: 3 },
    shadowRadius: 15,
    margin: 10,
    paddingBottom: __WEB__ ? 0 : 25,
  },
  floatingHeader: {
    width: '100%',
    backgroundColor: COLOR.altContrast,
    borderBottomWidth: 1,
    borderBottomColor: COLOR.altAccent,
    padding: 10,
    justifyContent: 'space-between',
    flexDirection: 'row',
  },
  detailsText: {
    ...FONT.medium,
    ...THEME.linkStyle,
    marginRight: 5,
  },
  arrowStyle: {
    tintColor: COLOR.callToAction,
    width: 10,
    height: 14,
  },
});
